import { Banknote, CreditCard, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";

export function RefundPanel({ absTotal, isPaxEnabled, processCashPayment, processCardPayment }) {
  return (
    <div className="space-y-3">
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
        <div className="text-sm text-red-700 mb-2">Refund Amount</div>
        <div className="text-3xl font-bold text-red-800">${absTotal.toFixed(2)}</div>
      </div>
      <Button
        onClick={() => processCashPayment(absTotal)}
        className="w-full h-14 bg-red-600 hover:bg-red-700 text-white rounded-xl text-lg font-bold"
      >
        <Banknote className="w-5 h-5 mr-2" />
        REFUND CASH ${absTotal.toFixed(2)}
      </Button>
      {isPaxEnabled && (
        <div className="grid grid-cols-2 gap-2">
          <Button
            onClick={() => processCardPayment("CREDIT")}
            className="h-11 bg-blue-600 hover:bg-blue-700 text-white rounded-xl"
          >
            <CreditCard className="w-4 h-4 mr-1" />
            Credit Refund
          </Button>
          <Button
            onClick={() => processCardPayment("DEBIT")}
            className="h-11 bg-purple-600 hover:bg-purple-700 text-white rounded-xl"
          >
            <Smartphone className="w-4 h-4 mr-1" />
            Debit Refund
          </Button>
        </div>
      )}
    </div>
  );
}
